import { CART_DRAWER_PLACEMENT } from "./cartDrawerRuntime";

// Default selector strategy for Dawn-like cart drawers.
// Placement choice (above/below) decides selector + insert position.
export const DAWN_LIKE_CART_DRAWER_SLOTS = {
  [CART_DRAWER_PLACEMENT.ABOVE_CART_ITEMS]: {
    selector: { type: "id", value: "CartDrawer-Item-1" },
    insertPosition: "beforebegin",
    tableRow: false,
  },
  [CART_DRAWER_PLACEMENT.BELOW_CART_ITEMS]: {
    selector: { type: "group", value: ".cart-items tbody" },
    insertPosition: "beforeend",
    tableRow: false,
  },
};

function getSelectorByType(type, value) {
  switch (type) {
    case "tag":
    case "group":
      return value;
    case "class":
      return `.${value}`;
    case "id":
      return `#${value}`;
    default:
      return value;
  }
}

export function getCartDrawerEmbedConfigForPlacement(placement) {
  const slot = DAWN_LIKE_CART_DRAWER_SLOTS[placement];
  if (!slot?.selector) return null;
  return {
    css_selector: getSelectorByType(slot.selector.type, slot.selector.value),
    position: slot.insertPosition,
  };
}

